var exports = {
  "kL": "ChannelStickersArea.module__container___SmZrOG",
  "gI": "ChannelStickersArea.module__standalone___SmZrOG",
  "Qs": "ChannelStickersArea.module__content___SmZrOG",
  "UV": "ChannelStickersArea.module__stickerPreview___SmZrOG",
  "HF": "ChannelStickersArea.module__stickerImage___SmZrOG",
  "od": "ChannelStickersArea.module__stickerInfo___SmZrOG",
  "Zl": "ChannelStickersArea.module__stickerName___SmZrOG",
  "Gl": "ChannelStickersArea.module__stickerDescription___SmZrOG",
  "DT": "ChannelStickersArea.module__removeButton___SmZrOG",
  "Kk": "ChannelStickersArea.module__icon___SmZrOG",
};

module.exports = exports;
